import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import UserService from '../../services/UserService';
import moment from "moment";
import Modal from 'react-modal';
import { showLoading } from 'react-global-loading';
import CountryHeader from "./CountryHeader";
import CreateAssociationPractitionerUser from '../my-account/superadmin/users/AssociationPractitioner/CreateUser.js';

export const userData = localStorage.getItem('persist:root') ?
  JSON.parse(JSON.parse(localStorage.getItem('persist:root')).userData) : '';

const CountryUsers = (props) => {
  const [userData, setUserData] = useState();
  const [type, setType] = useState('view');
  const [countryId, setCountryId] = useState(props.match.params.id);
  const [categoryId, setCategoryId] = useState(props.match.params.catId);
  const [usersList, setUsersList] = useState([]);
  const [showUserViewModal, setShowUserViewModal] = useState(false)

  useEffect(() => {
    showLoading(true);
    getUsersList();
  }, []);

  const getUsersList = () => {
    UserService.getAllUsersByCountry({ 'blog_id': countryId, 'category': categoryId }).then((result) => {
      if (!result) {
        return;
      }
      console.log("Full user list:", result); // Log the full API response
      setUsersList(result);
      showLoading(false);
    }).catch((err) => {
      console.error(err);
    });
  };
  const childStats = {
    userData,
    type,
    showUserViewModal
  };

  const handleCallback = (childData) => {

    setCategoryId(childData.id)
  };
  return (
    <div className="container pt-2">
      <CountryHeader parentCallback={handleCallback} category={categoryId} country={countryId} />
      <Modal
        isOpen={showUserViewModal}
        shouldCloseOnOverlayClick={true}
        ariaHideApp={false}
      >
        <CreateAssociationPractitionerUser dismissModal={(e) => (setShowUserViewModal(false))} {...childStats} />

      </Modal>
      <div className="row bg-light p-2 pt-4 mt-5 mb-3 rounded rounded-2">
        <div className="col-12">
          <h3 className="mb-3">Users</h3>
          <div className="row view-group" id="products2">
            {/* below is the product card */}
            {(showLoading && usersList.length > 0) ? usersList.map((item, index) =>
              <div key={index} className="col-md-3 mb-3"
              // onClick={(e) => (setUserData(item), setShowUserViewModal(true))}
              >
                <div className="card p-3 event-card crdev">
                  <div className="imgrel">
                    <img src={item.image} className="card-img-top rounded" style={{ height: '150px', objectFit: 'cover' }} />
                  </div>
                  <div className="evtxcn px-0">
                    <h4 className="evh">
                      <span className="evhd crop-text">{item.name}</span>
                    </h4>
                    <span className="muted d-block mt-1 doccell crop-text">{item.name}</span>
                    <p className="evdes_nw">{item.email}</p>
                  </div>
                </div>

              </div>
            ) : <div className="col-12 mb-4">
              <div class="alert alert-success" role="alert">
                <h4 class="alert-heading">
                  <i class="fa fa-exclamation-circle me-1" aria-hidden="true"></i> Data Not Found!
                </h4>
                <p>We regret to inform you that the requested data could not be located or does not exist in our records. It is possible that the information you are seeking has not been documented, is not publicly available, or has been removed or archived.</p>
              </div>
            </div>}
          </div>
        </div>
      </div>
    </div >
  );
};

export default CountryUsers;
